import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MapPin } from "lucide-react";

export function Logo({ dark = false }) {
  return (
    <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
      <div className="w-8 h-8 rounded-lg bg-[#09090b] flex items-center justify-center">
        <MapPin size={17} color="#0ea5e9" strokeWidth={2.5} />
      </div>
      <span className="font-heading font-bold text-xl tracking-tight" style={{ color: dark ? "#fff" : "#09090b" }}>MapLift</span>
    </Link>
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          <a href="/#how" className="text-sm font-medium text-[#52525b] hover:text-[#09090b] transition-colors" data-testid="nav-how">How it works</a>
          <a href="/#features" className="text-sm font-medium text-[#52525b] hover:text-[#09090b] transition-colors" data-testid="nav-features">Features</a>
          <Link to="/pricing" className="text-sm font-medium text-[#52525b] hover:text-[#09090b] transition-colors" data-testid="nav-pricing">Pricing</Link>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link to="/dashboard" className="text-sm font-semibold text-[#09090b]" data-testid="nav-dashboard">Dashboard</Link>
              <button onClick={async () => { await logout(); nav("/"); }} className="text-sm font-medium text-[#52525b] hover:text-[#09090b]" data-testid="nav-logout">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-[#52525b] hover:text-[#09090b]" data-testid="nav-login">Log in</Link>
              <Link to="/register" className="text-sm font-semibold text-white bg-[#09090b] px-4 py-2 rounded-full hover:-translate-y-0.5 transition-transform" data-testid="nav-signup">Get started</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
